export const getPaymentsList = (query: string) => ({
	url: `/payments/admin/overview?${query}`,
	method: "GET",
});

// Run the merchant-payout settlement now (same logic as the cron). Real-time:
// settles every currently-eligible payout immediately.
export const processPayoutsURL = {
	url: `/payments/admin/process-payouts`,
	method: "POST",
};

// Stage a PENDING payout for settlement (admin/test affordance — in production
// this happens automatically after delivery + the return window).
export const markPayoutEligibleURL = (payoutId: string) => ({
	url: `/payments/admin/payouts/${payoutId}/mark-eligible`,
	method: "PATCH",
});

// Payout cron config (type MERCHANT_PAYOUT_CRON_JOB), under properties.cronExpression.
export const getPaymentConfigsURL = ({ page = 0, size = 10 }) => ({
	url: `/payments/configs?page=${page}&size=${size}`,
	method: "GET",
});

export const updatePaymentConfigURL = (configId: string) => ({
	url: `/payments/configs/${configId}`,
	method: "PATCH",
});
